module.exports = __webpack_public_path__ + "static/media/builtinv2-proverka celostnosti.95886bc7.png";